function initBeiratTabs() {
  document.querySelectorAll('.shopify-section--wissenschaftlicher-beirat [id^="bk-media-beirat-tabs-"]:not([data-beirat-tabs-init])').forEach(function (container) {
    var tabs = Array.prototype.slice.call(container.querySelectorAll('[role="tab"]'));
    var panels = Array.prototype.slice.call(container.querySelectorAll('[role="tabpanel"]'));
    var prevButton = container.querySelector('[data-beirat-prev]');
    var nextButton = container.querySelector('[data-beirat-next]');

    if (!tabs.length || !panels.length) return;

    container.setAttribute('data-beirat-tabs-init', 'true');

    var state = {
      activeIndex: tabs.findIndex(function (tab) {
        return tab.getAttribute('aria-selected') === 'true';
      }),
      intervalId: null,
      isHovered: false
    };

    if (state.activeIndex < 0) state.activeIndex = 0;

    function scrollTabIntoView(tab) {
      if (!tab || !tab.parentElement) return;
      tab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }

    function activateTab(index) {
      if (!tabs.length) return;

      state.activeIndex = (index + tabs.length) % tabs.length;

      tabs.forEach(function (tab, tabIndex) {
        var isActive = tabIndex === state.activeIndex;
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.tabIndex = isActive ? 0 : -1;
      });

      panels.forEach(function (panel, panelIndex) {
        var isActive = panelIndex === state.activeIndex;
        panel.classList.toggle('is-active', isActive);

        if (isActive) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });

      scrollTabIntoView(tabs[state.activeIndex]);
    }

    function nextTab() {
      activateTab(state.activeIndex + 1);
    }

    function prevTab() {
      activateTab(state.activeIndex - 1);
    }

    function stopAutoRotate() {
      if (state.intervalId) {
        clearInterval(state.intervalId);
        state.intervalId = null;
      }
    }

    function startAutoRotate() {
      stopAutoRotate();

      if (container.dataset.autoRotate !== 'true' || state.isHovered || tabs.length < 2) return;

      var interval = parseInt(container.dataset.rotateInterval, 10) || 5000;

      state.intervalId = window.setInterval(function () {
        if (!state.isHovered) nextTab();
      }, interval);
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        activateTab(index);
        startAutoRotate();
      });

      tab.addEventListener('keydown', function (event) {
        var nextIndex = state.activeIndex;

        if (event.key === 'ArrowRight') {
          nextIndex = state.activeIndex + 1;
        } else if (event.key === 'ArrowLeft') {
          nextIndex = state.activeIndex - 1;
        } else if (event.key === 'Home') {
          nextIndex = 0;
        } else if (event.key === 'End') {
          nextIndex = tabs.length - 1;
        } else {
          return;
        }

        event.preventDefault();
        activateTab(nextIndex);
        tabs[state.activeIndex].focus();
        startAutoRotate();
      });
    });

    if (prevButton) {
      prevButton.addEventListener('click', function () {
        prevTab();
        startAutoRotate();
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        nextTab();
        startAutoRotate();
      });
    }

    container.addEventListener('mouseenter', function () {
      state.isHovered = true;
      stopAutoRotate();
    });

    container.addEventListener('mouseleave', function () {
      state.isHovered = false;
      startAutoRotate();
    });

    container.addEventListener('focusin', function () {
      state.isHovered = true;
      stopAutoRotate();
    });

    container.addEventListener('focusout', function (event) {
      if (container.contains(event.relatedTarget)) return;
      state.isHovered = false;
      startAutoRotate();
    });

    activateTab(state.activeIndex);
    startAutoRotate();
  });
}

document.addEventListener('DOMContentLoaded', initBeiratTabs);
document.addEventListener('shopify:section:load', function () {
  setTimeout(initBeiratTabs, 100);
});
